(function ($) {
    if (!$('body').hasClass('viewing-upsell')) return;

    function send_product_to_cart(ele, productId, upsell_coupon_code) {
        var form_data = new FormData();
        ele.attr('disabled', true);
        ele.addClass('loading');

        form_data.append('action', 'simple_add_to_cart_upsold');
        form_data.append('product_id', productId);
        form_data.append('nonce', ThemeJS.Variables.Ajax.nonce);

        let checkout_url_append = '';
        if (upsell_coupon_code !== '') {
            checkout_url_append = `?wccc=${upsell_coupon_code}`;
        }

        fetch(woocommerce_params.ajax_url, {
            method: 'POST',
            body: form_data,
        }).then(response => response.json()).then(data => {
            ele.attr('disabled', false);
            ele.removeClass('loading');
            window.location = `${ThemeJS.Variables.Checkout_Url}${checkout_url_append}`;
        }).catch((error) => {
            ele.attr('disabled', false);
            ele.removeClass('loading');
            console.error('Error:', error);
        });
    }

    $(document).ready(function () {

        let upsell_to_product_id = $('#upsell_to_product_id').val();
        let upsell_from_product_id = $('#upsell_from_product_id').val();
        let upsell_coupon_code = $('#upsell_coupon_code').val();

        $('a[href="#yes"], a[href="#no"]').each(function () {
            $(this).addClass('fa-cog-btn');
            var linkText = $(this).text();
            var wrappedText = $('<span>').addClass('text').text(linkText);
            var spinner = $('<span>').addClass('fas fa-cog fa-spin');
            $(this).empty().append(wrappedText).append(spinner);
        });

        $('a[href="#yes"], [data-buy="yes"]').click(function (e) {
            e.preventDefault();
            send_product_to_cart($(this), upsell_to_product_id, upsell_coupon_code);
        });

        $('a[href="#no"]').click(function (e) {
            e.preventDefault();
            send_product_to_cart($(this), upsell_from_product_id, '');
        });
    });
})(jQuery);